export const secondaryPanelLayoutStyles = {
  left: 'auto',
  right: '22px',
  width: '438px',
  bottom: '70px',
};
